import api from '../..'

const getLesson = (lessonId: number) => {
  return api.get(`administration/lessons/${lessonId}`).then(({ data }) => {
    return data
  })
}

export default getLesson
